import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	uploadHeadingJwmSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-heading-jwm-spork',
		defaultMessage: 'Import data to a new business project',
		description: 'Heading for workflow for importing your work into a new Jira business project',
	},
	uploadDescriptionWithLinkJwmComplexspork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-description-with-link-jwm-complexspork',
		defaultMessage:
			'Create a new business project using imported data. If you’d like to import into an existing business project, <link>switch to the old experience</link>.',
		description: 'Import your work to create a new Jira project Description',
	},
	projectCreateHeadingJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-heading-jwm',
		defaultMessage: 'Create a project',
		description: 'Set up the project to finish your import heading',
	},
	projectCreateDescriptionJwmSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-description-jwm-spork',
		defaultMessage:
			'Create a new business project to import your data into. Aside from the project type, you can edit project details anytime in project settings. {br} {br}Required fields are marked with an asterisk.',
		description:
			'Description to inform user they need to name their project and customize the settings',
	},
	uploadCsvDropzoneHeadingJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-heading-jwm',
		defaultMessage: 'Import from CSV',
		description: 'Import from CSV heading',
	},
	uploadCsvDropzoneLearnMoreJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-learn-more-jwm',
		defaultMessage: 'Learn more about importing from a CSV file',
		description: 'Learn more link description',
	},
	mappingHeadingJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-heading-jwm',
		defaultMessage: 'Preview mapped data',
		description: 'Preview your project and map data as part of the import project flow heading',
	},
	mappingDescriptionWithLinkJwmSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-with-link-jwm-spork',
		defaultMessage:
			'Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We’ll create an issue in the Jira project for each row of data. <link>Learn more about how to map data from a CSV.</link>',
		description:
			'Description to inform user they should check their data looks correct in the table below and let them know they can use the header row to change the field types of each column',
	},
	mappingDescriptionJwmSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-jwm-spork',
		defaultMessage:
			'Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We’ll create an issue in the Jira project for each row of data. {link}',
		description:
			'Description to inform user they should check their data looks correct in the table below and let them know they can use the header row to change the field types of each column',
	},
	mappingLearnMoreJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-learn-more-jwm',
		defaultMessage: 'Learn more about how to map data from a CSV.',
		description: 'Learn more link description',
	},
	importFromOtherAppsHeadingJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-heading-jwm',
		defaultMessage: 'Other apps',
		description: 'Other apps heading',
	},
	importFromOtherAppsHelperMessageJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-helper-message-jwm',
		defaultMessage:
			'We’re working on the ability to directly import data from other apps. For now, you can import from other apps using our CSV importer. {link}',
		description:
			'Helper text to let users know what that support for other apps still needs to be built',
	},
	importFromOtherAppsLearnMoreOtherAppsJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-learn-more-other-apps-jwm',
		defaultMessage: 'Learn more about importing from other apps',
		description: 'Learn more link description',
	},
	projectCreateMoreOptionsJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-more-options-jwm',
		defaultMessage: 'Show project type and key',
		description:
			'Heading for more options accordion to show fields to configure project key and project type',
	},
	projectCreateHideMoreOptionsJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-hide-more-options-jwm',
		defaultMessage: 'Hide project type and key',
		description:
			'Heading for hide accordion to show fields to configure project key and project type',
	},
	mappingAdvancedOptionsHeading: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-heading',
		defaultMessage: 'Date and time format options',
		description:
			'Heading for the accordion that will show the advanced date and time format options',
	},
	mappingAdvancedOptionsPopupHeading: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-popup-heading',
		defaultMessage: 'Date and time format',
		description:
			'Heading for popup message shown to provide more information about the types of date formats supported',
	},
	mappingAdvancedOptionsPopupDescriptionJwm: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-popup-description-jwm',
		defaultMessage:
			'Specify how dates and times are formatted in your CSV file. We’ll read these based on your CSV language and region preferences. Use syntax valid for {linkStart}Simple Date Format{linkEnd}.',
		description:
			'Description for popup message shown to provide more information about the types of date formats supported',
	},
	uploadHeadingJswSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-heading-jsw-spork',
		defaultMessage: 'Import data to a new software project',
		description: 'Heading for workflow for importing your work into a new Jira software project',
	},
	uploadDescriptionWithLinkJswSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-description-with-link-jsw-spork',
		defaultMessage:
			'Create a new software project using imported data. If you’d like to import into an existing software project, <link>switch to the old experience</link>.',
		description: 'Import your work to create a new Jira project Description',
	},
	projectCreateHeadingJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-heading-jsw',
		defaultMessage: 'Set up a project',
		description: 'Set up the project to finish your import heading',
	},
	projectCreateHeadingSoftwareProject: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-heading-software-project',
		defaultMessage: 'Set up your new project',
		description:
			'Heading for the second step of any import into a software project in Jira. In this step users provide details for the project to be set up',
	},
	projectCreateDescriptionJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-description-jsw',
		defaultMessage:
			'Create a software project to import your data. Except for the project type, you can update other details in the Project settings anytime.',
		description:
			'Description to inform user they need to name their project and customize the settings',
	},
	projectCreateDescriptionSoftwareProject: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-description-software-project',
		defaultMessage:
			'Name and create your new project. Aside from the project type, you can update these details later. {br} {br}Required fields are marked with an asterisk.',
		description:
			'Description for the second step of any import into a software project in Jira. In this step users provide details for the project to be set up.',
	},
	uploadCsvDropzoneHeadingJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-heading-jsw',
		defaultMessage: 'Import from CSV',
		description: 'Import from CSV heading',
	},
	uploadCsvDropzoneLearnMoreJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-learn-more-jsw',
		defaultMessage: 'How to import from a CSV file',
		description: 'Learn more link description',
	},
	mappingHeadingJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-heading-jsw',
		defaultMessage: 'Preview mapped data',
		description: 'Preview your project and map data as part of the import project flow heading',
	},
	mappingDescriptionWithLinkJswSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-with-link-jsw-spork',
		defaultMessage:
			'Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We’ll create an issue in the Jira project for each row of data. <link>How to map data from a CSV.</link>',
		description:
			'Description to inform user they should check their data looks correct in the table below and let them know they can use the header row to change the field types of each column',
	},
	mappingDescriptionJswSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-jsw-spork',
		defaultMessage:
			'Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We’ll create an issue in the Jira project for each row of data. {link}',
		description:
			'Description to inform user they should check their data looks correct in the table below and let them know they can use the header row to change the field types of each column',
	},
	mappingLearnMoreJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-learn-more-jsw',
		defaultMessage: 'How to map data from a CSV.',
		description: 'Learn more link description',
	},
	importFromOtherAppsHeadingJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-heading-jsw',
		defaultMessage: 'Import from apps',
		description: 'Other apps heading',
	},
	importFromOtherAppsHelperMessageJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-helper-message-jsw',
		defaultMessage: 'We’re working on importers that will directly move your data from these apps.',
		description:
			'Helper text to let users know what that support for other apps still needs to be built',
	},
	projectCreateMoreOptionsJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-more-options-jsw',
		defaultMessage: 'Show more',
		description:
			'Heading for more options accordion to show fields to configure project key and project type',
	},
	projectCreateHideMoreOptionsJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.project-create-hide-more-options-jsw',
		defaultMessage: 'Hide more',
		description:
			'Heading for hide accordion to show fields to configure project key and project type',
	},
	mappingAdvancedOptionsPopupDescriptionJsw: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-popup-description-jsw',
		defaultMessage:
			'Select how dates and times are formatted in your CSV file. We’ll read these based on your CSV language and region preferences. Use syntax valid for {linkStart}Simple Date Format{linkEnd}.',
		description:
			'Description for popup message shown to provide more information about the types of date formats supported',
	},
	importInProgressHeading: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-heading',
		defaultMessage: 'We’re mapping out the new project',
		description: 'Heading for the Import in Progress screen',
	},
	importInProgressDescription: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-description',
		defaultMessage:
			"Take a quick break and we'll do the rest.{br}We'll take you to the project once it’s ready.",
		description:
			'Description to inform user they can take a quick break while the import is occurring',
	},
	importInProgressCreateProjectStep: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-create-project-step',
		defaultMessage: 'Creating a new project',
		description: 'Description of the import step that creates the project',
	},
	mappingDescriptionExistingProjectNonFinal: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-existing-project-non-final',
		defaultMessage:
			"{link} in the selected project, or select columns you want to exclude from the import. Using your CSV, we’ll create an issue for each row of data. This import won't alter any issues in the existing project.",
		description:
			'Description to inform user they should check their data looks correct in the table below and let them know they can use the header row to change the field types of each column',
	},
	mappingDescriptionWithLinkExistingProject: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-with-link-existing-project',
		defaultMessage:
			"<link>Map columns from your CSV to fields</link> in the selected project, or select columns you want to exclude from the import. Using your CSV, we’ll create an issue for each row of data. This import won't alter any issues in the existing project.",
		description:
			'Description to inform user they should check their data looks correct in the table below and let them know they can use the header row to change the field types of each column',
	},
	mappingLearnMoreExistingProjectNonFinal: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.mapping-learn-more-existing-project-non-final',
		defaultMessage: 'Map columns from your CSV to fields',
		description: 'Learn more link description',
	},
	emptyMessageNoTranslate: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.empty-message-no-translate',
		defaultMessage: '',
		description: 'empty string for defult cases',
	},
	close: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.close',
		defaultMessage: 'Close',
		description: 'Label for cross icon',
	},
	importInProgressHeadingExistingProject: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-heading-existing-project',
		defaultMessage: 'We’re importing your project',
		description: 'Heading for the Import in Progress screen for existing project',
	},
	importInProgressDescriptionExistingProject: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-description-existing-project',
		defaultMessage:
			'Feel free to close this window. You can continue to work in the background.{br}We will notify you once the import is complete. You can also track the progress from the project page.',
		description: 'Description to inform user they can close and import will happen in background',
	},
	importInProgressMappingDataStep: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-mapping-data-step',
		defaultMessage: 'Mapping data to your project',
		description: 'Description for mapping data to your project',
	},
	importInProgressErrorHeading: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-error-heading',
		defaultMessage: "We couldn't set up your project",
		description: 'Heading for when the import failed',
	},
	importInProgressErrorExistingProjectHeading: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-error-existing-project-heading',
		defaultMessage: "We couldn't import your data",
		description: 'Heading for when the import to existing project failed',
	},
	uploadFooterContinue: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-footer-continue',
		defaultMessage: 'Continue',
		description: 'Continue button',
	},
	uploadFooterCancel: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.upload-footer-cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button',
	},
	userMappingScreenDescriptionJwmSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.user-mapping-screen-description-jwm-spork',
		defaultMessage:
			'Enter a valid email address for each user to add them into your Jira project. Users without an email address won’t be imported into the project.',
		description: 'Description giving instructions on how to use the user email mapping table',
	},
	userMappingScreenDescriptionJswSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.user-mapping-screen-description-jsw-spork',
		defaultMessage:
			'Enter a valid email address for each user to add them into your Jira project. Users without an email address won’t be imported into the project.',
		description: 'Description giving instructions on how to use the user email mapping table',
	},
	entityStatsUserMessageJwmSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.entity-stats-user-message-jwm-spork',
		defaultMessage: 'Users won’t get an email when they’re added to Jira.',
		description:
			'Info message to indicate that users will not get emailed when they are added to the project',
	},
	entityStatsUserMessageJswSpork: {
		id: 'project-create-importer-upload-flow.common.utils.project-specific-content.entity-stats-user-message-jsw-spork',
		defaultMessage: 'Users won’t get an email when they’re added to Jira.',
		description:
			'Info message to indicate that users will not get emailed when they are added to the project',
	},
});
